<template>
  <Error v-if="shouldCreateWorkspace" error="should-create-workspace" />
  <section v-else id="bucket">
    <Bucket />
  </section>
</template>

<script>
import Bucket from '../../components/Buckets/Bucket/Bucket.vue';

export default {
  components: {
    Bucket,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped src="./Bucket.scss"></style>
